module.exports = __webpack_public_path__ + "img/PorkIreland.b5a81b75.png";